import React from "react";
import "./About.css";
import { Type } from "./Type";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import EmailIcon from "@material-ui/icons/Email";
import TwitterIcon from "@material-ui/icons/Twitter";
import { Introduction } from "./Introduction";
import { Timeline } from "./Timeline";
import { Techstacks } from "./Techstacks";
import { FaAngleDown } from "react-icons/fa";

export const About = () => {

  const toggleNavList = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 50; // adjust this value as needed
      const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };


  return (
    <>
      <div className="about center fullscreen">
     
        <h1 data-aos="fade-right" className="mobileHead">
          Hello, I am <br /><span className="about__name " >Adith Pozhekadavil</span>
        </h1>
        <div className="typer">
          <Type />
        </div>

     
        <div className="about__contact center">
          <a
            href="https://github.com/cloneartist"
            aria-label="github"
            target="_blank"
            rel="noreferrer"
            className="link link--icon"
          >
            <GitHubIcon />
          </a>
          <a
            href="mailto:cloneartist@gmail.com"
            target="_blank"
            rel="noreferrer"
            aria-label="mail"
            className="link link--icon"
          >
            <EmailIcon />
          </a>
    
          <a
            href="https://www.linkedin.com/in/adith-anandhan/"
            aria-label="linkedin"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
          >
            <LinkedInIcon />
          </a>
          <a
            href="https://twitter.com/icuriousdev"
            aria-label="twitter"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
          >
            <TwitterIcon />
          </a>
        </div>

        <button
          className="btnResume"
          onClick={() => {
            window.open(
              "https://drive.google.com/file/d/abcd/view?usp=sharing"
            );
          }}
        >
          Resume
        </button>

      </div>
      <div className="scroll-down">

        <a  > <FaAngleDown onClick={() => toggleNavList("#about")} /></a>

      </div>

      <Introduction />
      <Timeline />
      <section id="#skills">
        <Techstacks />
      </section>
    </>
  );
};
